import React from 'react';
import { connect } from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

// Tab
import MaintenanceWorkList from '../../../../maintenance/helper/component/MaintenanceWorkList';
import MaintenanceRequestList from '../../../../maintenance/helper/component/MaintenanceRequestList';

// Modal
import ModalMaintenanceRequest from '../../../../maintenance/helper/component/Modal/ModalMaintenanceRequest.js';
import ModalReportproblem from '../../../../maintenance/helper/component/Modal/ModalReportproblem.js';

import { StoreUserInfoFromMobile } from "user/action";
import windowStop from '../../../../utils/windowStop';

const { ReactNativeWebView } = window;

class MaintenancByAssetScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: '1',
      newData  : {},
      hardReload: false,
      modalMaintenanceRequest: false,
      modalReportProblem: false,
      asset:{
        assetAlias : props.match.params.AssetAlias,
        assetName  : props.match.params.AssetName,
        owner      : props.match.params.Owner,
      },
    }

    this.setAsset           = this.setAsset.bind(this);
    this.toggleTab          = this.toggleTab.bind(this);
    this.openModal          = this.openModal.bind(this);
    this.closeModal         = this.closeModal.bind(this);
    this.toggleModalProblem = this.toggleModalProblem.bind(this);
    this.updateRow          = this.updateRow.bind(this);
    this.stopHardReload     = this.stopHardReload.bind(this);
    this.handleMobile       = this.handleMobile.bind(this); 
  }

  openModal() {
    this.setState({
      modalMaintenanceRequest: true
    })
  }

  closeModal() {
    this.setState({modalMaintenanceRequest: false})
  }

  toggleModalProblem(){
    this.setState({modalReportProblem: !this.state.modalReportProblem})
  }

  toggleTab(tab) {
    if(this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  stopHardReload() {
    this.setState({hardReload: false})
  }

  updateRow() {
    this.setState({hardReload: true})
  }

  setAsset(name, owner) {
    this.setState({asset: {
      assetName  : name,
      assetAlias : this.props.match.params.AssetAlias,
      owner      : owner,
    }})
  }

  handleMobile({ data }){
    this.props.RunRedux(
      StoreUserInfoFromMobile(JSON.parse(data))
    );
  }

  componentDidMount() {
    if(ReactNativeWebView){
      document.addEventListener("message", this.handleMobile);
      window.addEventListener("message", this.handleMobile);
      if(!this.props.UserReducer.username) {
        ReactNativeWebView.postMessage("mounted");
      }
    }
  }

  componentWillUnmount() {
    windowStop()
    if(ReactNativeWebView){
      document.removeEventListener("message", this.handleMobile);
      window.removeEventListener("message", this.handleMobile);
    }
  }

  renderButton() {
    if(this.state.asset.owner === this.props.UserReducer.username) {
      return (
        <div className="flex-right b-ml-res">
          <button onClick={()=>this.toggleModalProblem()} type="button" className="btn btn-sm btn-danger">
            <i className="fa fa-dot-circle-o"></i>&nbsp;Report Problem
          </button>
          &nbsp;
          <button onClick={()=>this.openModal()} type="button" className="btn btn-sm btn-primary">
            <i className="fa fa-dot-circle-o"></i>&nbsp;Request maintenance
          </button>
        </div>
      )
    }
  }

  render() {
    const props = this.props;
    
    return (
      <div className="animated fadeIn">
        <div className="row">
            <div className="col-md-12">
              <div className="card no-border">
                <div className="card-block white-background">
                  <div className="page-header">
                    <h4>
                      {this.props.history.length > 1 && (
                        <button onClick={()=>this.props.history.goBack()} className="button-back btn-link no-underline" role="presentation"><i className="fa fa-arrow-left"></i></button>
                      )}
                      &nbsp;
                      <span>Maintenance List</span>&nbsp;
                      <small>for asset</small>&nbsp;<span>{decodeURIComponent(this.state.asset.assetName)}</span>
                      {this.renderButton()}
                    </h4>
                  </div>
                  <hr/>
                  <Nav tabs>
                    <NavItem>
                      <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggleTab('1'); }} >
                        Maintenance Work &nbsp;
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggleTab('2'); }} >
                        Maintenance Request &nbsp;
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={this.state.activeTab}>
                    {/* Tab 1 */}
                    <TabPane tabId="1" className="no-padding">
                      <div className="card no-border">
                        <MaintenanceWorkList 
                          {...props}
                          setAsset={this.setAsset}
                          asset={this.state.asset}
                        />
                      </div>
                    </TabPane>
                    <TabPane tabId="2" className="no-padding">
                      <div className="card no-border">
                        <MaintenanceRequestList 
                          {...props}
                          asset={this.state.asset}
                          newData={this.state.newData}
                          hardReload={this.state.hardReload}
                          stopHardReload={this.stopHardReload}
                        />
                      </div>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
          </div>

        <ModalMaintenanceRequest 
          modalMaintenanceRequest = {this.state.modalMaintenanceRequest}
          openModal               = {this.openModal}
          closeModal              = {this.closeModal}
          asset                   = {this.state.asset}
          updateRow               = {this.updateRow}
          UserReducer             = {this.props.UserReducer}
          toggleTab               = {this.toggleTab} 
        />
        <ModalReportproblem
          modalReportProblem = {this.state.modalReportProblem} 
          toggleModal        = {this.toggleModalProblem}
          asset              = {this.state.asset}
          UserReducer        = {this.props.UserReducer}
        />
      </div>
    );
  }
}
 
const mapStateToProps = state => {
  return {
    UserReducer: state.UserReducer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MaintenancByAssetScreen)


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/maintenance/maintenance_by_asset.js